import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import {Portlet, PortletBody} from "../../../components/Portlet";
import {Table} from "reactstrap";
import numberFormat from "../../../helpers/numberFormat";
import _ from 'lodash'

const toNumber = (value) => {
  const num = Number(value)
  return Number.isFinite(num) ? num : 0
}

const BonusCalculation = ({data}) => {
  const [bonuses, setBonuses] = useState({
    tickets: 0,
    refunds: 0,
    services: 0
  })
  const ticketPrice = toNumber(bonuses.tickets)
  const refundPrice = toNumber(bonuses.refunds)
  const servicePrice = toNumber(bonuses.services)

  const rows = (data || []).map(row => {
    const ticketCount = toNumber(row.ticketCount)
    const refundCount = toNumber(row.refundCount)
    const serviceCount = toNumber(row.serviceCount)
    return {
      operator: row.operator,
      ticketCount,
      refundCount,
      serviceCount,
      total: ticketCount * ticketPrice + refundCount * refundPrice + serviceCount * servicePrice
    }
  })

  const totalTickets = _.sumBy(rows, 'ticketCount')
  const totalRefunds = _.sumBy(rows, 'refundCount')
  const totalServices = _.sumBy(rows, 'serviceCount')
  const totalByTickets = totalTickets * ticketPrice
  const totalByRefunds = totalRefunds * refundPrice
  const totalByServices = totalServices * servicePrice
  const grandTotal = totalByTickets + totalByRefunds + totalByServices

  return (
    <Portlet>
      <PortletBody>
        <div className={'d-flex align-items-center gap-2 mb-2'}>
          <div style={{position: 'relative', width: '10.5rem'}}>
            <label className={'absolutLabel'}>Цена за билеты</label>
            <Form.Control
              value={bonuses.tickets}
              onChange={(e) => setBonuses(q => ({...q, tickets: e.target.value}))}
              type={'number'}
            />
          </div>
          <div className={'d-flex align-items-center gap-2'}>
            <div style={{position: 'relative', width: '10.5rem'}}>
              <label className={'absolutLabel'}>Цена за возвраты</label>
              <Form.Control
                value={bonuses.refunds}
                onChange={(e) => setBonuses(q => ({...q, refunds: e.target.value}))}
                type={'number'}
              />
            </div>
          </div>
          <div className={'d-flex align-items-center gap-2'}>
            <div style={{position: 'relative', width: '10.5rem'}}>
              <label className={'absolutLabel'}>Цена за услуги</label>
              <Form.Control
                value={bonuses.services}
                onChange={(e) => setBonuses(q => ({...q, services: e.target.value}))}
                type={'number'}
              />
            </div>
          </div>
        </div>
        <Table striped bordered>
          <thead>
          <tr>
            <td>Имя</td>
            <th>Билетов</th>
            <th>Возвратов</th>
            <th>Услуг</th>
            <th>Итого</th>
          </tr>
          </thead>
          <tbody>
          {rows.map((row, index) => {
            return <tr key={index}>
              <td>{row.operator}</td>
              <td>{numberFormat(row.ticketCount)}</td>
              <td>{numberFormat(row.refundCount)}</td>
              <td>{numberFormat(row.serviceCount)}</td>
              <td>{numberFormat(row.total)}</td>
            </tr>
          })}
          <tr style={{backgroundColor:'#00800059'}}>
            <th>Итого</th>
            <td>{numberFormat(totalTickets)}</td>
            <td>{numberFormat(totalRefunds)}</td>
            <td>{numberFormat(totalServices)}</td>
            <td>{numberFormat(grandTotal)}</td>
          </tr>
          <tr>
            <th>Итого по типу</th>
            <td>{numberFormat(totalByTickets)}</td>
            <td>{numberFormat(totalByRefunds)}</td>
            <td>{numberFormat(totalByServices)}</td>
            <td>{numberFormat(grandTotal)}</td>
          </tr>
          </tbody>
        </Table>
      </PortletBody>


    </Portlet>
  );
};

export default BonusCalculation;
